import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateGovtOrderNumber = ({
  govt_order_details_id,
  formRef,
  getData,
  rowId,
  setRowId,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const [company, setCompany] = useState([]);
  const [selectCompanyId, setSelectCompanyId] = useState("");
  const [productId, setProductId] = useState("");
  const [yardId, setYardID] = useState("");
  const [closingStockInYard, setClosingStockInYard] = useState("");
  const [singleGovtOrderNumber, setSingleGovtOrderNumber] = useState([]);
  const [initialYardIds, setInitialYardIds] = useState([]);
  const [initialCompanyIds, setInitialCompanyIds] = useState([]);
  const [initialProductNameIds, setInitialProductNameIds] = useState([]);
  const [orderNumbers, setOrderNumbers] = useState([
    { company_id: "", yard_id: "", product_name_id: "", order_qty: "" },
  ]);
  const [product, setProduct] = useState(Array(orderNumbers?.length).fill([]));
  const [yard, setYard] = useState(Array(orderNumbers?.length).fill([]));
  const [rowAddData, setRowAddData] = useState({
    order_number: "",
    date: "",
    status: "",
    last_date_offer: "",
  });

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (rowId) {
      handleSingleGovtOrderNumber();
    }
  }, [rowId]);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  useEffect(() => {
    if (singleGovtOrderNumber) {
      const list = singleGovtOrderNumber?.order_details?.map((item) => ({
        yard_id: item.yard_id,
        yard_name: item.yard_name,
        company_id: item.company_id,
        company_name: item.company_name,
        location: item.location,
        product_name_id: item.product_name_id,
        product_name: item.product_name,
        order_qty: item.order_qty,
      }));
      setOrderNumbers(list);
      setInitialYardIds(
        singleGovtOrderNumber?.order_details?.map((item) => item.yard_id)
      );
      setInitialProductNameIds(
        singleGovtOrderNumber?.order_details?.map(
          (item) => item.product_name_id
        )
      );
      setInitialCompanyIds(
        singleGovtOrderNumber?.order_details?.map((item) => item.company_id)
      );
    }
  }, [singleGovtOrderNumber]);

  useEffect(() => {
    if (initialCompanyIds && initialCompanyIds?.length > 0) {
      const productLists = [];
      const yardLists = [];
      initialCompanyIds.forEach((companyId, index) => {
        const selectedCompany = company.find(
          (item) => item.id === parseInt(companyId)
        );
        if (selectedCompany) {
          const yards = selectedCompany.companyYard.map((yard) => ({
            id: yard.id,
            yard_name: yard.yard_name,
          }));
          yardLists[index] = yards;

          const products = selectedCompany.productName.map((product) => ({
            id: product.id,
            size: product.size,
          }));
          productLists[index] = products;
        }
      });
      setProduct(productLists);
      setYard(yardLists);
    }
  }, [initialCompanyIds]);

  const addOrderNumberRow = () => {
    setOrderNumbers([
      ...orderNumbers,
      { company_id: "", yard_id: "", product_name_id: "", order_qty: "" },
    ]);
    setSelectCompanyId(""); // Reset selectCompanyId to empty string
    setProductId(""); // Reset productId to empty string
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSingleGovtOrderNumber(() => {
      return {
        ...singleGovtOrderNumber,
        [name]: value,
      };
    });
  };

  const handleSingleGovtOrderNumber = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/govt-order/single-govt-order-number/${user_id}/${rowId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setSingleGovtOrderNumber(result.data);
    } else {
      setSingleGovtOrderNumber([]);
    }
  };


  // const getSingleYardDetailClosing = async () => {
  //   const BASE_URL = `${SERVER_URL}/api/yard-details/single-yard-details/${user_id}?company_id=${selectCompanyId}&product_name_id=${productId}&yard_id=${yardId}`;
  //   const res = await fetch(BASE_URL, {
  //     method: "GET",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //   });
  //   const result = await res.json();
  //   if (res.ok) {
  //     setClosingStockInYard(result.data);
  //   } else {
  //     setClosingStockInYard("");
  //   }
  // };

  // useEffect(() => {
  //   if (yardId) {
  //     getSingleYardDetailClosing();
  //   }
  // }, [yardId, productId, selectCompanyId]);

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { id, order_number, date, status, total_order_qty, last_date_offer } =
      singleGovtOrderNumber;
    let BASE_URL = SERVER_URL + `/api/govt-order/govt-order-number/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        govt_order_details_id: govt_order_details_id,
        order_number,
        status,
        date,
        last_date_offer,
        // order_details: orderNumbers,
        total_order_qty,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      // resetFields();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  function resetFields() {
    setSingleGovtOrderNumber({
      order_number: "",
      date: "",
      status: "",
      total_order_qty: "",
      last_date_offer: "",
    });
    setProduct([]);
    setYardID("");
    setRowId("");
    setSelectCompanyId("");
    setClosingStockInYard("");
    setProductId("");
    setOrderNumbers([
      { company_id: "", yard_id: "", product_name_id: "", order_qty: "" },
    ]);
  }
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="update"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Order Number Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div> */}
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                      //   ref={formRef}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="order">Order Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="order_number"
                                id="order"
                                placeholder="Order Number"
                                readOnly
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.order_number}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="date"
                                id="date"
                                placeholder="Date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.date}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="total_order_qty">
                              Last Date Of Offer
                            </label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="last_date_offer"
                                id="total_order_qty"
                                placeholder=" Last Date Of Offer"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.last_date_offer}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="total_order_qty">
                              Total Order Qty
                            </label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="total_order_qty"
                                id="total_order_qty"
                                placeholder="total_order_qty"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.total_order_qty}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="status">Status</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="status"
                                id="status"
                                placeholder="Status"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.status}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {singleGovtOrderNumber?.order_details?.length > 0 &&
                        orderNumbers?.map((order, index) => {
                          const isInitialYardId =
                            order.yard_id &&
                            initialYardIds.includes(order.yard_id);
                          const isInitialCompanyId =
                            order.company_id &&
                            initialCompanyIds.includes(order.company_id);
                          const isInitialProductNameId =
                            order.product_name_id &&
                            initialProductNameIds.includes(
                              order.product_name_id
                            );
                          return (
                            <div key={index} className="row">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="Company">Company Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.company_id}
                                    disabled={isInitialCompanyId}
                                    onChange={(e) =>
                                      handleCompanyChange(e, index)
                                    }
                                    id="Company"
                                  >
                                    <option value="">Select Company</option>
                                    {company &&
                                      company?.length > 0 &&
                                      company.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.company_name}, ${item.location}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="product">Product Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.product_name_id}
                                    onChange={(e) =>
                                      handleProductChange(e, index)
                                    }
                                    disabled={
                                      !selectCompanyId || isInitialProductNameId
                                    }
                                  >
                                    <option value="">Select Product</option>
                                    {product &&
                                      product[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.size}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="yard">Yard Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.yard_id}
                                    onChange={(e) => handleYardChange(e, index)}
                                    disabled={
                                      !selectCompanyId || isInitialYardId
                                    }
                                  >
                                    <option value="">Select yard</option>
                                    {yard &&
                                      yard[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.yard_name}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="qty">Order Quantity</label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={order.order_qty}
                                      onChange={(e) =>
                                        handleQtyChange(e, index)
                                      }
                                      placeholder="Order Quantity"
                                    />
                                    <span className="input-group-append ml-2">
                                      <div className="col-md-2">
                                        <button
                                          type="button"
                                          title="Remove"
                                          disabled={
                                            isInitialCompanyId ||
                                            isInitialProductNameId ||
                                            isInitialYardId
                                          }
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() =>
                                            removeOrderNumberRow(index)
                                          }
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })} */}
                      {/* <span className="input-group-append ml-2">
                        <button
                          className="btn btn-primary mt-3"
                          type="button"
                          onClick={addOrderNumberRow}
                        >
                          Add More
                        </button>
                      </span> */}
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateGovtOrderNumber;
